import { render, staticRenderFns } from "./DealerInfo.vue?vue&type=template&id=0002e145&scoped=true&"
import script from "./DealerInfo.vue?vue&type=script&lang=js&"
export * from "./DealerInfo.vue?vue&type=script&lang=js&"
import style0 from "./DealerInfo.vue?vue&type=style&index=0&id=0002e145&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0002e145",
  null
  
)

export default component.exports